import { z } from 'zod'

export const trainerXanoAuxExceptionResponseSchema = z.record(z.unknown())
export type TrainerXanoAuxExceptionResponse = z.infer<typeof trainerXanoAuxExceptionResponseSchema>
